const BuyTitle = () => (
    <section id="buy-title">
       <div className="container-fluid pt-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-9 col-11">
                    <h1>Try out GlucoGen<sup>17</sup> Naturals to reclaim your health today</h1>      
                </div>
            </div>
        </div>
    </section>
);

export default BuyTitle;